export default {
    listagem: {
        titulo_pagina: 'List of Integrations',
        novo: 'Create New Integration',
        campos_tabela: 'Table Fields',
        table: {
            empty: 'No Integration Found',
            nome: 'Name',
            protocolo: 'Protocol',
            mnemonico: 'Mnemonic',
            fabricante: 'Manufacturer',
            tipo_integracao: 'Integration Type',
            complemento: 'Complement',
            tipo_complemento: 'Complemento type',
            forcar_complemento: 'Force complement',
            tamanho_recipiente: 'Recipient identifier size',
            file_format: 'File Format',
            host_homologacao: 'Homologation Host',
            host_producao: 'Production host',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Integration',
            editar: 'Edit Integration'
        },
        fieldsets: {
            informacoes: 'Information',
            comunicacao: 'Communication',
            hosts: 'Hosts',
            camada: 'Anti Corruption Layer'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Integration Name'
            },
            mnemonico: {
                label: 'Mnemonic',
                description: 'Acronym of Integration'
            },
            tipo_integracao: {
                label: 'Type of Integration',
                description: 'Type of Integration used'
            },
            fabricante: {
                label: 'Manufacturer',
                description: 'Integration Manufacturer'
            },
            protocolo: {
                label: 'Protocol',
                description: 'Integration communication protocol'
            },
            formato_arquivo: {
                label: 'File Format',
                description: 'File format used in the Integration'
            },
            pubsub_topic_result_out: {
                label: 'Result PubSub Topic',
                description: 'Output Result PubSub Topic'
            },
            pubsub_topic_order_out: {
                label: 'Order PubSub Topic',
                description: 'Output Order PubSub Topic'
            },
            pubsub_topic_label_out: {
                label: 'Label\'s PubSub Topic',
                description: 'Output Label PubSub Topic'
            },
            host_homologacao: {
                label: 'Homologation Host',
                description: 'Host used to approve the Integration'
            },
            host_producao: {
                label: 'Production Host',
                description: 'Host where the Integration will point'
            },
            empresa: {
                label: 'Company',
                description: 'Company that will be able to perform the Integration'
            },
            equipamento: {
                label: 'Equipment',
                description: 'Equipment authorized for Integration'
            },
            status: {
                label: 'Status',
                description: 'Integration active or inactive status'
            },
            sport: {
                label: 'Sports Integration',
                description: 'Sports integration that works with athletes'
            },
            bloquear_dexpara: {
                label: 'Block Send',
                description: 'Blocks sending in case of mapping error'
            },
            bypass_material_complement: {
                label: 'Bypass Complementary Material',
                description: 'Allows integration processing without requiring complementary material mapping'
            },
            botao_salvar : 'Save Integration'
        },
        create: {
            success: 'Integration successfully created!',
            error: 'Error creating integration!'
        },
        update: {
            success: 'Integration successfully edited!',
            error: 'Error editing integration!'
        },
        errors: {
            possible_specimens_linked: 'The integration type cannot be changed because there are Possible Specimens registered linked to this integration'
        }
    }
}
